import React from "react";
import {
  Box, TableBody, TableCell, TableContainer, TableHead, TableRow, Table
} from '@material-ui/core';
import moment from 'moment';

function handleDateTime(dateTime) {
  const dateTtime = new Date(dateTime);
  const date = dateTtime.toLocaleDateString('en-CA');
  const time = dateTtime.toLocaleTimeString('en-GB', {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: true
  });
  return (
    <>
      {date}
      <br />
      <strong>{time}</strong>
    </>
  );
}

export default class ComponentToPrint extends React.Component {
  render() {
    const breakData = this.props.breakData;
    const searchData = this.props.selectedSearchValues;
    const breakDetail = this.props.breakDetail;

    const cellStyle = {
      border: '1px solid black', padding: '1px',
      fontSize: '0.9rem',
    };

    return (<div>
      <div>
        <h3><center><u>Employee Break Details Report</u></center></h3>
        <h4><center>{searchData.groupName} - {searchData.factoryName}</center></h4>
        <h4><center>{searchData.registrationNumber === '' ? 'All Employees' : 'Reg No: ' + searchData.registrationNumber}</center></h4>
        <h4><center>{searchData.date}</center></h4>
        <h4><center>{searchData.employeeTypeID == 0 ? 'Employee Type: All' : 'Employee Type: ' + searchData.employeeTypeName}</center></h4>
        <div>&nbsp;</div>
        <div>
          <Box minWidth={1050} style={{ paddingLeft: "10px", paddingRight: "10px" }}>
            <TableContainer>
              <Table aria-label="caption table">
                <TableHead>
                  <TableRow style={{ border: '1px solid black' }}>
                    <TableCell align={'center'} style={cellStyle}>Registration Number</TableCell>
                    <TableCell align={'center'} style={cellStyle}>Employee Name</TableCell>
                    <TableCell align={'center'} style={cellStyle}>Employee Type</TableCell>
                    <TableCell align={'center'} style={cellStyle}>In Time</TableCell>
                    <TableCell align={'center'} style={cellStyle}>Break Type</TableCell>
                    <TableCell align={'center'} style={cellStyle}>Start Time</TableCell>
                    <TableCell align={'center'} style={cellStyle}>End Time</TableCell>
                    <TableCell align={'center'} style={cellStyle}>Time Duration</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {(() => {
                    const groupedData = breakData.reduce((acc, data) => {
                      const regNum = data.registrationNumber || '-';
                      if (!acc[regNum]) acc[regNum] = [];
                      acc[regNum].push(data);
                      return acc;
                    }, {});
                    return Object.entries(groupedData).map(([registrationNumber, employees]) => (
                      <React.Fragment key={registrationNumber}>
                        {employees.map((data, index) => (
                          <TableRow key={`${registrationNumber}-${index}`} style={{ border: '1px solid black' }}>
                            {index === 0 && (
                              <TableCell
                                align={'left'}
                                component="th"
                                scope="row"
                                style={{ ...cellStyle, verticalAlign: 'middle' }}
                                rowSpan={employees.length}
                              >
                                {registrationNumber}
                              </TableCell>
                            )}
                            <TableCell align={'left'} component="th" scope="row" style={cellStyle}>
                              {data.employeeName}
                            </TableCell>
                            <TableCell align={'left'} component="th" scope="row" style={cellStyle}>
                              {data.employeeTypeName}
                            </TableCell>
                            <TableCell align={'center'} component="th" scope="row" style={cellStyle}>
                              {data.inTime ? handleDateTime(data.inTime) : '-'}
                            </TableCell>
                            <TableCell align={'left'} component="th" scope="row" style={cellStyle}>
                              {data.employeeIntervalTypeName}
                            </TableCell>
                            <TableCell align={'center'} component="th" scope="row" style={cellStyle}>
                              {data.startTime ? handleDateTime(data.startTime) : '-'}
                            </TableCell>
                            <TableCell align={'center'} component="th" scope="row" style={cellStyle}>
                              {!data.endTime || data.endTime === '00:00:00' || data.endTime === 'null' ? (
                                <span style={{ color: 'red', fontWeight: 'bold' }}>Pending</span>
                              ) : (
                                handleDateTime(data.endTime)
                              )}
                            </TableCell>
                            <TableCell align={'center'} component="th" scope="row" style={cellStyle}>
                              {(() => {
                                if (!data.endTime || data.endTime === '00:00:00' || data.endTime === 'null') {
                                  return <span style={{ color: 'red', fontWeight: 'bold' }}>Pending</span>;
                                }
                                if (!data.startTime) return '-';
                                const start = moment(data.startTime, 'YYYY-MM-DD hh:mm:ss a');
                                let end = moment(data.endTime, 'YYYY-MM-DD hh:mm:ss a');
                                if (!start.isValid() || !end.isValid()) return '-';
                                if (end.isBefore(start)) {
                                  end.add(1, 'day');
                                }
                                const duration = moment.duration(end.diff(start));
                                if (duration.asSeconds() <= 0) return '-';
                                const days = Math.floor(duration.asDays());
                                const hours = duration.hours();
                                const minutes = duration.minutes();
                                const seconds = duration.seconds();
                                return `${days}d ${hours}h ${minutes}m ${seconds}s`;
                              })()}
                            </TableCell>
                          </TableRow>
                        ))}
                      </React.Fragment>
                    ));
                  })()}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </div>
      </div>
    </div>
    );
  }
}